import React, { useContext, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_SHARE } from "../../Schema/Shares";
import { translateLauguage } from "../../Function/Translate";

export default function DeleteShares({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  // console.log("editData::",editData)

  const [deleteShare] = useMutation(DELETE_SHARE, {
    onCompleted: ({ deleteShare }) => {
      // console.log("deleteShare::", deleteShare);
      setLoading(false);
      if (deleteShare?.status === true) {
        setAlert(true, "success", deleteShare?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteShare?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteShare({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">លុបភាគហ៊ុន</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography className="delete-descript">
              តើអ្នកពិតជាចង់លុបទិន្នន័យនេះមែនទេ?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-delete" fullWidth>
                កំពុងដំណើរការ...
              </Button>
            ) : (
              <Button className="btn-delete" fullWidth onClick={handleDelete}>
                លុប
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
